module.exports = __webpack_public_path__ + "img/hone-solution5.d4c80c0b.png";